<template>
    <div v-bind="$attrs" @click="tryOpenModal" class="cursor-pointer">
        <slot></slot>
    </div>
    <ModalCustom
        :is-open="state.isLoadModalOpen"
        @close="tryCloseLoadModal"
        title="Load Video"
    >
        <div class="w-[80vw] max-h-[50vh] overflow-y-auto">
            <loading-circle class="m-12" v-if="state.isLoading" />
            <div v-else>
                <div v-if="noVideos" class="text-center">No videos found</div>
                <div class="mt-2">
                    <div
                        class="
                            flex
                            items-center
                            w-full
                            pb-2
                            mb-4
                            gap-2
                            cursor-pointer
                            border-b border-b-gray-300
                        "
                        @click="toggleOpenGroup(-10)"
                    >
                        <ion-icon
                            name="caret-down"
                            v-if="isGroupOpen(-10)"
                        ></ion-icon>
                        <ion-icon name="caret-forward" v-else></ion-icon>
                        <h6 class="text-sm flex-grow-1 w-full">
                            Tagged Videos
                        </h6>
                    </div>
                    <div class="flex gap-4 p-4" v-if="isGroupOpen(-10)">
                        <div
                            class="
                                grid grid-cols-3
                                gap-4
                                lg:grid-cols-4
                                flex-grow flex-shrink
                            "
                        >
                            <div
                                v-if="
                                    !state.play?.videos ||
                                    state.play?.videos?.length == 0
                                "
                                class="col-span-4 self-center"
                            >
                                <div class="text-center text-gray-500">
                                    No tagged videos found
                                </div>
                            </div>
                            <div
                                v-for="video in state.play?.videos"
                                :key="video.id"
                                class="
                                    pt-2
                                    px-4
                                    pb-4
                                    bg-white
                                    shadow-xl
                                    rounded-lg
                                    border border-gray-200
                                    text-center
                                    cursor-pointer
                                    hover:border-primary
                                "
                            >
                                <div class="flex mb-2">
                                    <div
                                        class="
                                            block
                                            text-md
                                            relative
                                            w-full
                                            text-center
                                        "
                                    >
                                        {{ video.title }}
                                    </div>
                                    <context-menu>
                                        <li>
                                            <a
                                                class="
                                                    py-2
                                                    px-6
                                                    flex flex-row
                                                    items-center
                                                    text-left
                                                    gap-2
                                                    cursor-pointer
                                                    hover:bg-gray-300
                                                    rounded-lg
                                                "
                                                @click="untagPlay(video)"
                                            >
                                                <div
                                                    class="
                                                        flex-grow-1
                                                        flex-shrink-0
                                                        font-slab
                                                        mt-1
                                                    "
                                                >
                                                    Un-tag
                                                </div>
                                            </a>
                                        </li>
                                    </context-menu>
                                </div>
                                <div
                                    class="
                                        relative
                                        group
                                        text-sm
                                        md:text-base
                                        fit-content
                                        flex flex-col
                                        overflow-hidden
                                    "
                                >
                                    <VideoPlayer
                                        :thumbnail="video.thumbnail"
                                        :url="video.url"
                                    ></VideoPlayer>
                                </div>
                                <button
                                    class="
                                        bg-gradient-to-br
                                        from-primary
                                        to-primaryLight
                                        text-white
                                        rounded-lg
                                        p-1
                                        px-4
                                        mt-4
                                    "
                                    @click="loadVideo(video)"
                                >
                                    View
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="mt-4"
                    v-for="group in videoCollections"
                    :key="group.id"
                >
                    <div
                        class="
                            flex
                            items-center
                            w-full
                            pb-2
                            mb-4
                            gap-2
                            cursor-pointer
                            border-b border-b-gray-300
                        "
                        @click="toggleOpenGroup(group.id)"
                    >
                        <ion-icon
                            name="caret-down"
                            v-if="isGroupOpen(group.id)"
                        ></ion-icon>
                        <ion-icon name="caret-forward" v-else></ion-icon>
                        <h6 class="text-sm flex-grow-1 w-full">
                            {{ group.name }}
                        </h6>
                    </div>
                    <div
                        class="flex gap-4 mt-1 p-4"
                        v-if="isGroupOpen(group.id)"
                    >
                        <div
                            class="
                                grid grid-cols-3
                                gap-4
                                lg:grid-cols-4
                                flex-grow flex-shrink
                            "
                        >
                            <div
                                v-if="group.videos?.length === 0"
                                class="col-span-4 self-center"
                            >
                                <div class="text-center text-gray-500">
                                    No videos found
                                </div>
                            </div>
                            <div
                                v-for="video in group.videos"
                                :key="video.id"
                                class="
                                    p-4
                                    bg-white
                                    shadow-xl
                                    rounded-lg
                                    border border-gray-200
                                    text-center
                                    cursor-pointer
                                    hover:border-primary
                                "
                                @click.self="loadVideo(video)"
                            >
                                <div class="block text-md mb-2">
                                    {{ video.title }}
                                </div>
                                <div
                                    class="
                                        relative
                                        group
                                        text-sm
                                        md:text-base
                                        fit-content
                                        flex flex-col
                                        overflow-hidden
                                    "
                                >
                                    <VideoPlayer
                                        :thumbnail="video.thumbnail"
                                        :url="video.url"
                                    ></VideoPlayer>
                                </div>
                                <button
                                    class="
                                        bg-gradient-to-br
                                        from-green-300
                                        to-green-500
                                        text-white
                                        rounded-lg
                                        p-1
                                        px-4
                                        mt-4
                                    "
                                    @click="tagPlay(video)"
                                >
                                    Tag
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { computed, onMounted, reactive, watch } from "vue";
import LoadingCircle from "./LoadingCircle.vue";
import ModalCustom from "./ModalCustom.vue";
import AppButton from "./AppButton.vue";
import VideoPlayer from "./VideoPlayer.vue";

const props = defineProps([
    "videoApi",
    "videoGroupApi",
    "whiteboardApi",
    "play",
]);
const emit = defineEmits(["loaded", "tagged", "saved"]);
const state = reactive({
    videos: [],
    play: props.play || null,
    openGroups: [-10],
});

watch(
    () => props.play,
    (play) => {
        state.play = play;
    }
);

const tryCloseLoadModal = () => {
    if (state.isLoading) {
        return;
    }

    state.isLoadModalOpen = false;
};

const videoCollections = computed(() => {
    const indexes = state.play?.videos?.map((v) => v.id) || [];
    if (!state.videoGroups.map) {
        return [];
    }
    return state.videoGroups?.map((group) => {
        let videos = [];
        if (group.id === -2) {
            videos = state.videos.filter(
                (video) => !video.video_group_id && !video.room_id
            );
        } else if (group.id === -3) {
            videos = state.videos.filter(
                (video) => !video.video_group_id && video.room_id
            );
        } else {
            videos = state.videos.filter((video) => {
                return (
                    video.video_group_id === group.id &&
                    !indexes.includes(video.id)
                );
            });
        }
        return {
            id: group.id,
            name: group.name,
            videos,
        };
    });
});

const noVideos = computed(() => {
    let total = 0;
    if (state.play) {
        total += state.play.videos?.length;
    }

    total += state.videos?.length;

    return total === 0;
});

const availableVideos = computed(() => {
    if (!state.play) {
        return state.videos;
    }

    return state.videos.filter((video) => {
        return !state.play.videos?.some((v) => v.id === video.id);
    });
});

function loadVideo(video) {
    const frame = document.getElementById("meeting_iframe");
    const action = "video";

    if (frame) {
        frame.contentWindow.postMessage(
            {
                action,
                data: JSON.stringify(video),
            },
            props.whiteboardApi
        );
    }

    state.isLoadModalOpen = false;
}

async function tryOpenModal() {
    emit("loaded");
    state.isLoadModalOpen = true;
    state.isLoading = true;
    try {
        await refreshData();
    } catch {}
    state.isLoading = false;
}

async function refreshData() {
    state.videos = (await axios.get(props.videoApi, {})).data;
    state.videoGroups = (await axios.get(props.videoGroupApi, {})).data;
}

async function tagPlay(video) {
    if (!state.play) {
        emit("saved", video);
        return;
    }
    await axios.post("/plays/tag-video", {
        play_id: state.play.play_id,
        video_id: video.id,
    });
    if (!state.play.videos) {
        state.play.videos = [];
    }
    state.play.videos.push(video);
    emit("tagged", state.play);
}

async function untagPlay(video) {
    if (!state.play) {
        return;
    }
    await axios.post("/plays/untag-video", {
        play_id: state.play.play_id,
        video_id: video.id,
    });
    state.play.videos = state.play.videos.filter((v) => v.id !== video.id);
    emit("tagged", state.play);
}

function toggleOpenGroup(groupId) {
    if (state.openGroups.includes(groupId)) {
        state.openGroups = state.openGroups.filter((g) => g !== groupId);
    } else {
        state.openGroups.push(groupId);
    }
}

function isGroupOpen(groupId) {
    return state.openGroups.includes(groupId);
}

onMounted(() => {
    refreshData();
});
</script>

<style scoped></style>
